import { render, staticRenderFns } from "./leave-base.vue?vue&type=template&id=67219334&scoped=true&"
import script from "./leave-base.vue?vue&type=script&lang=ts&"
export * from "./leave-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67219334",
  null
  
)

export default component.exports